import React, { useState } from 'react';
import QRCodeForm from './components/QRCodeForm';
import QRCodeDisplay from './components/QRCodeDisplay';
import ShareOptions from './components/ShareOptions';
import generateQRCode from './utils/generateQRCode';

const App: React.FC = () => {
    const [url, setUrl] = useState<string>('');
    const [qrCode, setQrCode] = useState<string | null>(null);

    const handleUrlSubmit = async (submittedUrl: string) => {
        setUrl(submittedUrl);
        try {
            // Await the asynchronous generateQRCode function
            const generatedQRCode = await generateQRCode(submittedUrl);
            setQrCode(generatedQRCode);
        } catch (error) {
            console.error('Error generating QR code:', error);
        }
    };

    return (
        <div>
            <h1>QR Code Generator</h1>
            <QRCodeForm onSubmit={handleUrlSubmit} />
            {qrCode && (
                <>
                    <QRCodeDisplay qrCodeUrl={qrCode} />
                    <ShareOptions qrCodeUrl={qrCode} />
                </>
            )}
        </div>
    );
};

export default App;